import React, { useEffect, useState } from "react"
import { Box, Modal, TextField, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import { apiTransactionSendClientTransaction } from "../../../../services/Admin/transaction"
import MsgError from '../../../../components/MsgError'
import { LoadingButton } from "@mui/lab";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    pt: 2,
    pb: 2,
    minWidth: { xs: 320, sm: 500, md: 700, lg: 850 },
    maxWidth: { xs: '90vw', sm: 850 },
    borderRadius: 4,
    position: "relative",
    outline: 'none'
};

export default function ModalSendTransaction({ open, setOpen, transactionId }) {
    const [loading, setLoading] = useState(false)
    const [mesFactura, setMesFactura] = useState(new Date().getMonth() + 1)
    const [anyFactura, setAnyFactura] = useState(new Date().getFullYear())
    const [warningEmailText, setWarningEmailText] = useState("")
    const [errorMsg, setErrorMsg] = useState("")

    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]

    const handleSend = () => {
        // Send month name (e.g. "Enero") instead of numeric value
        const payload = { transactionId, mesFactura: months[mesFactura - 1], anyFactura, warningEmailText }
        setErrorMsg("")
        setLoading(true)

        apiTransactionSendClientTransaction(payload)
            .then(() => {
                setLoading(false)
                setOpen(false)
            })
            .catch(() => {
                setLoading(false)
                setErrorMsg("Error al enviar la factura al cliente")
            })
    }

    useEffect(() => {
        setErrorMsg("")
    }, [open])

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box sx={{ textAlign: 'left', mt: 2, mb: 2, p: 4, pt: 0, pb: 0 }}>
                    <h2 style={{ textAlign: 'center', fontFamily: 'AdminFontMedium, Raleway, sans-serif', fontWeight: 600, marginBottom: 16, fontSize: 23 }}>
                        Enviar la factura al cliente
                    </h2>

                    <div style={{ display: 'flex', gap: 10, width: '100%', marginTop: 12, flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        <div style={{ width: '49%' }}>
                            <TextField
                                label="Mes factura"
                                select
                                value={mesFactura}
                                onChange={(e) => setMesFactura(Number(e.target.value))}
                                fullWidth
                            >
                                {months.map((m, i) => (
                                    <MenuItem key={i} value={i + 1}>{m}</MenuItem>
                                ))}
                            </TextField>
                        </div>
                        <div style={{ width: '49%' }}>
                            <TextField
                                label="Año factura"
                                value={anyFactura}
                                onChange={(e) => setAnyFactura(Number(e.target.value))}
                                type="number"
                                fullWidth
                            />
                        </div>
                        <div style={{ width: '100%', marginTop: 12 }}>
                            <TextField
                                label="Texto aviso email"
                                value={warningEmailText}
                                onChange={(e) => setWarningEmailText(e.target.value)}
                                multiline
                                rows={4}
                                fullWidth
                            />
                        </div>

                    </div>

                    {errorMsg ? (
                        <div style={{ width: '100%', marginBottom: 8, marginTop: 12 }}>
                            <MsgError msg={[errorMsg]} />
                        </div>
                    ) : null}

                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={() => setOpen(false)}
                                variant="contained"
                                className="MuiButton-containedCancel"
                                fullWidth
                            >
                                Cancelar
                            </Button>
                        </div>
                        <div style={{ width: "50%" }}>
                            <LoadingButton
                                onClick={handleSend}
                                type="button"
                                loading={loading}
                                loadingPosition="start"
                                variant="contained"
                                fullWidth
                            >
                                Guardar
                            </LoadingButton>
                        </div>
                    </div>
                </Box>
            </Box>
        </Modal>
    );
}
